import AuthService from '../services/auth.service';
import router from '../router';

// Pridobi uporabnika iz localStorage, če obstaja
const user = JSON.parse(localStorage.getItem('user'));
const adminUserBeforeImpersonation = JSON.parse(localStorage.getItem('adminUserBeforeImpersonation'));

// Začetno stanje modula
const initialState = {
  status: {
    loggedIn: Boolean(user)
  },
  user: user || null,
  adminUserBeforeImpersonation: adminUserBeforeImpersonation || null
};

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
          user => {
            commit('loginSuccess', user);
            return Promise.resolve(user);
          },
          error => {
            commit('loginFailure');
            return Promise.reject(error);
          }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
      router.push('/login'); // Preusmeri na login stran
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
          response => {
            commit('registerSuccess');
            return Promise.resolve(response.data);
          },
          error => {
            commit('registerFailure');
            return Promise.reject(error);
          }
      );
    },
    forgotPassword({ commit }, user) {
      return AuthService.forgotPassword(user).then(
          response => {
            return Promise.resolve(response.data);
          },
          error => {
            return Promise.reject(error);
          }
      );
    },
    resetPassword({ commit }, payload) {
      return AuthService.resetPassword(payload.token, payload.password, payload.passwordConfirm).then(
          response => {
            return Promise.resolve(response.data);
          },
          error => {
            return Promise.reject(error);
          }
      );
    },
    handleExpiredToken({ commit }) {
      commit('logout'); // Počisti stanje uporabnika
      localStorage.removeItem('user'); // Počisti shranjenega uporabnika iz localStorage
      localStorage.removeItem('adminUserBeforeImpersonation');
      router.push('/login'); // Preusmeri na login stran
    },
    impersonateUser({ commit, state }, impersonatedUser) {
      commit('impersonateUser', {
        adminUser: state.adminUserBeforeImpersonation || state.user,
        impersonatedUser
      });
      router.push('/ads');
    },
    returnToAdmin({ commit, state }) {
      if (!state.adminUserBeforeImpersonation) {
        return;
      }

      commit('returnToAdmin');
      router.push('/admin');
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
      state.adminUserBeforeImpersonation = null;
      console.log('User roles:', user.roles); // Dodano za preverjanje vlog uporabnika
      localStorage.setItem('user', JSON.stringify(user)); // Shranjevanje uporabnika v localStorage
      localStorage.removeItem('adminUserBeforeImpersonation');
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.adminUserBeforeImpersonation = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    impersonateUser(state, { adminUser, impersonatedUser }) {
      state.status.loggedIn = true;
      state.user = impersonatedUser;
      state.adminUserBeforeImpersonation = adminUser;
      localStorage.setItem('user', JSON.stringify(impersonatedUser));
      localStorage.setItem('adminUserBeforeImpersonation', JSON.stringify(adminUser));
    },
    returnToAdmin(state) {
      state.status.loggedIn = true;
      state.user = state.adminUserBeforeImpersonation;
      state.adminUserBeforeImpersonation = null;
      localStorage.setItem('user', JSON.stringify(state.user));
      localStorage.removeItem('adminUserBeforeImpersonation');
    }
  }
};
